// Format instants on the organisation's home clock (falls back to the viewer's device zone).
export const browserTz = () => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch { return 'UTC'; } };

const safe = (tz) => { try { new Intl.DateTimeFormat('en', { timeZone: tz }); return tz; } catch { return browserTz(); } };

export const tzAbbrev = (tz, at = new Date()) => {
  try {
    const part = new Intl.DateTimeFormat('en', { timeZone: safe(tz), timeZoneName: 'short' }).formatToParts(at).find((p) => p.type === 'timeZoneName');
    return part ? part.value : '';
  } catch { return ''; }
};

export const fmtOrg = (iso, tz, opts = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, { ...opts, timeZone: safe(tz) });
};

export const fmtOrgDate = (iso, tz, opts = { day: 'numeric', month: 'short', year: 'numeric' }) => fmtOrg(iso, tz, opts);

export const fmtOrgTime = (iso, tz) => fmtOrg(iso, tz, { hour: '2-digit', minute: '2-digit' });

export const sameOrgDay = (iso, tz, ref = new Date()) => fmtOrg(iso, tz, { year: 'numeric', month: '2-digit', day: '2-digit' }) === fmtOrg(ref, tz, { year: 'numeric', month: '2-digit', day: '2-digit' });

// Short suffix only when the org clock differs from the viewer's — keeps the common case quiet.
export const tzSuffix = (tz) => (tz && tz !== browserTz() ? ` ${tzAbbrev(tz)}` : '');
